var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "sage-export-pending-dialog-container" },
    [
      _c("div", { staticClass: "info-banner" }, [
        _c("span", { class: [_setup.infoIcon, "info-icon"] }),
        _c("span", { staticClass: "info-title" }, [
          _vm._v(_vm._s(_setup.texts.title)),
        ]),
      ]),
      _c("div", { staticClass: "dialog-body" }, [
        _c("p", { staticClass: "description" }, [
          _vm._v(_vm._s(_setup.texts.description)),
        ]),
        _c("p", { staticClass: "records-included" }, [
          _vm._v(_vm._s(_setup.texts.recordsIncluded)),
        ]),
        _c("p", { staticClass: "records-line" }, [
          _vm._v(_vm._s(_setup.texts.recordsLine)),
        ]),
      ]),
      _c(_setup.CustomDialogActionButtonsComponent, {
        attrs: {
          primaryButtonText: _setup.texts.primaryButton,
          secondaryButtonText: _setup.texts.secondaryButton,
          mainAction: _setup.onAccept,
          showSecondaryButton: true,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }